import { FC } from "react";
import { MiDetailFields } from "@miplatform/components";
import { IMiListField } from "@miplatform/types";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import {
  DepartmentConfigData,
  DepartmentDetailsConfigViewProps,
} from "../../ConfigDepartments.types";

export const DepartmentConfigDetailsTabView: FC<
  DepartmentDetailsConfigViewProps
> = ({ form }) => {
  const { control } = form;

  const departmentDetailFields: IMiListField<DepartmentConfigData>[] = [
    {
      label: "Name",
      name: "name",
      formControl: control,
      required: true,
    },
    {
      label: "Abbreviation",
      name: "abbreviation",
      formControl: control,
      setValue: (e: React.ChangeEvent<HTMLInputElement>) => {
        form.setValue("abbreviation", e.target.value.toUpperCase(), {
          shouldDirty: true,
          shouldValidate: true,
        });
      },
      required: true,
      maxLength: 5,
    },
    {
      label: "Description",
      name: "description",
      formControl: control,
      required: true,
      width: "100%",
    },
  ];

  return (
    <ConfigAccordionHeader title="Department Details">
      <MiDetailFields detailFields={departmentDetailFields} />
    </ConfigAccordionHeader>
  );
};
